import "Scss/landings/check-equipment/index.scss";

import { initHeader } from "./header";
import { initSidebar } from "./sidebar";
import { initForms } from "./forms";
import { accordionInit } from "Components/accordion";
import { Modal } from "Components/modal";
// import { initContentBlocks } from "./content-blocks";
import { initClientIDs } from "Components/clientIDs";

window.bmgroup20 = {};

initHeader();
initSidebar();
// initContentBlocks();
accordionInit("accordion");
Modal.init();
initForms();
initClientIDs();
